'use strict';

angular.module('internal.users')
    .controller('InternalUserHistory', ['$scope', '$rootScope', 'DataChangeLog', '$stateParams', function ($scope, $rootScope, DataChangeLog, $stateParams) {
        $scope.resetUser();
        $scope.isDataChangeLogOpen = true;
        $scope.isStatusChangeLogOpen = true;

        DataChangeLog.get({ user_id: $stateParams.id }).then(function (dataChangeLog) {
            $scope.dataChangeLog = dataChangeLog;
            $scope.loading = false;
        })

        DataChangeLog.get({ user_id: $stateParams.id, user_status: true }).then(function (dataChangeLog) {
            $scope.UserStatusChangeLog = dataChangeLog;
            $scope.loading = false;
        })

        $scope.columns = [
            {
                label: 'Change Date',
                field: 'created_on',
                type: 'datetime'
            },
            {
                label: 'Modified By',
                field: 'created_by'
            },
            {
                label: 'Previous Values',
                field: 'old_values',
                type: 'ckeditor'
            },
            {
                label: 'New Values',
                field: 'new_values',
                type: 'ckeditor'
            },
        ];

        $scope.filters = [
            {
                name: 'Date',
                field: 'created_on',
                type: 'days',
                options: [
                    { id: 0, name: 'Today' },
                    { id: 1, name: 'Yesterday' },
                    { id: 7, name: 'Last 7 Days' },
                    { id: 30, name: 'Last 30 Days' },
                    { id: 90, name: 'Last 90 Days' }
                ]
            }
        ]

        $scope.statusfilters = [
            {
                name: 'Date',
                field: 'created_on',
                type: 'days',
                options: [
                    { id: 0, name: 'Today' },
                    { id: 1, name: 'Yesterday' },
                    { id: 7, name: 'Last 7 Days' },
                    { id: 30, name: 'Last 30 Days' },
                    { id: 90, name: 'Last 90 Days' }
                ]
            }
        ]
    }])
;